//INTERNAL
export const ROUTE_PO = "/:id?";
export const ROUTE_RESULT = "/result/:id/:pm/:type?";
export const ROUTE_NOT_FOUND = "*";
export const ROUTE_PRIVACY_POLICY = "/privacy-policy";
export const ROUTE_DATA_PROCESSOR = "/data-processor";

//EXTERNAL
export const ROUTE_TRANSLATED = "https://translated.com";
export const ROUTE_TRANSLATED_CONTACTS = "https://translated.com/contact-us";
export const ROUTE_TERMS = "https://translated.com/top/terms-and-conditions";
